module.exports = __webpack_public_path__ + "assets/e9ed97ab6498f94067159b9870df1939.png";